module.exports = __webpack_public_path__ + "static/media/1768A1HJ.fc9ba9cf.jpg";